export const SOLUTIONS = [
  {
    slug: "industrial-fabrication",
    title: "Industrial Fabrication",
    short: "Structural steel, platforms, chutes, hoppers and custom fabricated components — built to drawings and site requirements.",
    image: "/images/steel/s16.jpg",
    cta: "Explore Industrial Fabrication",
    heroLine: "Heavy-duty steel fabrication for demanding Saudi industrial environments.",
    intro:
      "SABAKT fabricates structural and process steelwork for plants, contractors and industrial operators across the Kingdom. Every component is manufactured against client drawings, dimensions and site conditions — engineered for fit, strength and service life.",
    capabilities: [
      "Structural steel & equipment structures",
      "Platforms, walkways & handrails",
      "Frames, brackets & guards",
      "Ducts, chutes, hoppers & bins",
      "Pipe supports & industrial supports",
      "Custom fabricated components to drawing",
    ],
    value:
      "Fabrication is treated as an engineering exercise, not a workshop task. Material selection, weld preparation and wear-zone reinforcement are considered before cutting begins — so components arrive ready to work, not ready to fail.",
    seo: "Steel fabrication Saudi Arabia · Industrial fabrication Riyadh · Metal fabrication KSA",
  },
  {
    slug: "wear-protection",
    title: "Wear Protection & Wear Parts",
    short: "Hardox, Chromium Carbide Overlay (CCO), liners and hardfacing — engineered wear solutions that extend component life.",
    image: "/images/cement/c09.jpg",
    cta: "Explore Wear Protection",
    heroLine: "Longer component life. Fewer emergency repairs. Better maintenance planning.",
    intro:
      "Abrasion and impact destroy industrial components long before their structural life is over. As the authorized channel partner of Diffusion Engineers Limited, SABAKT supplies and fabricates wear-resistant solutions — Hardox wear plates, Chromium Carbide Overlay (CCO), hardfaced liners and hardfaced components — matched to the actual wear mechanism in your plant.",
    capabilities: [
      "Hardox wear plates & parts",
      "Chromium Carbide Overlay (CCO) plates",
      "Chute, hopper & crusher liners",
      "Conveyor transfer-point protection",
      "Impact plates & abrasion-resistant components",
      "Hardfacing & custom wear parts",
    ],
    value:
      "The business case is simple: longer component life, fewer emergency repairs, planned instead of unplanned shutdowns, and reduced downtime cost per tonne produced. We help you choose between Hardox, CCO and hardfacing based on abrasion, impact and temperature — not habit.",
    seo: "Wear plates Saudi Arabia · Hardox Riyadh · CCO wear plates KSA · Chute liners Saudi Arabia",
  },
  {
    slug: "equipment-reconditioning",
    title: "Equipment Reconditioning",
    short: "Repair, rebuild and restore heavy components — excavator buckets, wear zones and structures — instead of replacing them.",
    image: "/images/cement/c19.jpg",
    cta: "Explore Reconditioning",
    heroLine: "Repair it. Rebuild it. Put it back to work.",
    intro:
      "Replacing heavy industrial components is not always the best solution. SABAKT reconditions worn and damaged equipment through engineered repair, hardfacing and dimensional restoration — returning components to service at a fraction of replacement cost and lead time.",
    capabilities: [
      "Excavator bucket reconditioning",
      "Bucket crack repair & structural repair",
      "Hardfacing & wear-zone rebuilding",
      "Dimensional & edge/lip restoration",
      "Welding repair & component reclamation",
      "Machining & industrial equipment restoration",
    ],
    value:
      "Every reconditioning job starts with inspection: what failed, why it failed, and what must change so it does not fail the same way again. The result is a component that is not just repaired — it is often returned to service stronger than the original wear specification.",
    seo: "Excavator bucket repair Saudi Arabia · Bucket reconditioning Riyadh · Hardfacing services KSA",
    featured: {
      title: "Excavator Bucket Reconditioning",
      text: "Restore worn excavator buckets and extend their service life through engineered repair, hardfacing and wear-resistant material application. Serving mining, quarry and construction fleets across Saudi Arabia.",
      cta: "Request Bucket Inspection",
    },
  },
  {
    slug: "industrial-maintenance",
    title: "Industrial Maintenance Support",
    short: "Shutdown support, rapid fabrication and repair solutions built around plant maintenance schedules.",
    image: "/images/cement/c17.jpg",
    cta: "Explore Maintenance Support",
    heroLine: "Support built around your shutdown window — not ours.",
    intro:
      "When a plant stops, every hour has a cost. SABAKT supports maintenance teams and contractors with rapid fabrication, repair and wear-protection services aligned to planned shutdowns, turnaround scopes and reliability improvement programs.",
    capabilities: [
      "Planned shutdown & turnaround support",
      "Rapid repair fabrication",
      "Wear-part replacement programs",
      "Reliability improvement scopes",
      "On-site measurement & assessment",
      "Maintenance contractor support",
    ],
    value:
      "We work to your maintenance plan: pre-shutdown surveys, pre-fabricated replacement components, and wear parts ready before the line stops — so the shutdown is spent installing, not waiting.",
    seo: "Industrial maintenance Saudi Arabia · Plant shutdown support Riyadh",
  },
  {
    slug: "storage-tanks",
    title: "Diesel & Water Storage Tanks",
    short: "Custom steel tanks with supports, ladders, platforms and pipe interfaces — fabricated to project requirements.",
    image: "/images/steel/s53.jpg",
    cta: "Request Tank Fabrication Quote",
    heroLine: "Steel storage tanks fabricated to your capacity, dimensions and site conditions.",
    intro:
      "SABAKT fabricates diesel and water storage tanks for industrial, construction and infrastructure projects across Saudi Arabia. Tanks are manufactured according to project requirements — capacity, dimensions, nozzle orientation and site conditions — together with the associated steelwork.",
    capabilities: [
      "Diesel storage tanks",
      "Water storage tanks",
      "Custom steel tanks to specification",
      "Tank supports & saddles",
      "Ladders, platforms & handrails",
      "Nozzles & pipe interfaces",
    ],
    value:
      "Tanks are designed and fabricated according to applicable project specifications and required standards. Where a project specification defines a standard, we fabricate to it — we do not claim certifications we do not hold.",
    seo: "Diesel storage tanks Saudi Arabia · Water tanks Riyadh · Steel storage tanks KSA",
  },
  {
    slug: "concrete-block-plants",
    title: "Concrete & Block Plant Solutions",
    short: "Silos, conveyors, hoppers, bins and wear protection for ready-mix, block and precast operations.",
    image: "/images/concrete/b09.jpg",
    cta: "Discuss Your Plant Requirement",
    heroLine: "Fabrication and wear protection for the plants that build the Kingdom.",
    intro:
      "SABAKT provides complete wear and tear solutions for concrete batching plants and block manufacturing plants — through reverse engineering, site inspection, dimension verification and on-site installation support. We manufacture wear parts compatible with leading international brands including Liebherr, BHS, SICOMA, ELBA, MASA, HESS and MEKA.",
    capabilities: [
      "Concrete plant fabrication & custom steelwork",
      "Silos, hoppers, bins & chutes",
      "Conveyors & material handling components",
      "Wear protection for high-abrasion zones",
      "Plant repair & structural fatigue correction",
      "Block plant components",
    ],
    value:
      "We know the failure modes: abrasion in chutes, impact at transfer points, material leakage, structural fatigue and hopper damage. SABAKT addresses the cause — geometry, material and wear package — not just the symptom.",
    seo: "Concrete plant fabrication Saudi Arabia · Block plant components Riyadh",
  },
  {
    slug: "cement-mining-solutions",
    title: "Cement, Steel & Mining Solutions",
    short: "Wear parts, hardfacing, reconditioning and fabrication for the Kingdom's heaviest industries.",
    image: "/images/cement/c05.jpg",
    cta: "Explore Heavy Industry Solutions",
    heroLine: "Abrasion. Impact. Uptime. We engineer for all three.",
    intro:
      "Cement plants, steel plants, mines and quarries share one enemy: wear under load. SABAKT serves these industries with wear parts, hardfacing, component reconditioning and heavy fabrication focused on uptime, equipment life and maintenance cost per tonne.",
    capabilities: [
      "Cement: chutes, hoppers, crushers, conveyors, bins, wear liners, ducts",
      "Steel: wear protection, fabricated components, structural steel, equipment repair",
      "Mining & quarry: buckets, crusher components, liners, wear plates",
      "Hardfacing & reconditioning programs",
      "Material handling equipment fabrication",
      "Heavy equipment repair support",
    ],
    value:
      "The conversation is always commercial: how many hours of production does a failure cost, and what does the engineered solution save? We specify wear packages and reconditioning scopes against that number.",
    seo: "Cement plant wear parts Saudi Arabia · Mining fabrication KSA · Steel plant maintenance Riyadh",
  },
];
